import lib from '@/library'

const state = {
  navigationSections: { }
}

const getters = {
  navigationSections (state) {
    return state.navigationSections
  },
  isMarketingPrefExist (state) {
    const currentState = window.ctsautoconf.STATE
    const accSummComponentsPerState = state.navigationSections && state.navigationSections[`ACCOUNT_SUMMARY_COMPONENTS_${currentState}`]
    const accSettingsPerState = accSummComponentsPerState && accSummComponentsPerState.fwnavigationgroups && accSummComponentsPerState.fwnavigationgroups.filter(navitem => (navitem.text === 'AccountSettings'))
    const accSummComponents = state.navigationSections && state.navigationSections[`ACCOUNT_SUMMARY_COMPONENTS`]
    const accSettings = accSummComponents && accSummComponents.fwnavigationgroups && accSummComponents.fwnavigationgroups.filter(navitem => (navitem.text === 'AccountSettings'))
    const finalAccSettings = accSettingsPerState || accSettings
    return finalAccSettings && (finalAccSettings[0].fwnavigationitems.find(item => item.action === 'MarketingPreferences') !== undefined)
  }
}

const mutations = {
  setNavigationSections (state, navigationsections) {
    state.navigationSections = navigationsections
  }
}

const actions = {
  fetchSiteNavigation (context) {
    lib.kansas.pssitenav().then(response => {
      if (response.data && response.data.fwnavigationsection) {
        let sections = {}
        response.data.fwnavigationsection.forEach(fwnavigationsection => {
          sections[fwnavigationsection.id] = fwnavigationsection
        })

        context.commit('setNavigationSections', sections)
      } else {
        context.commit('setNavigationSections', { })
      }
    }).catch((error) => {
      console.log(error)
      // context.commit('setNavigationSections', { })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sitenavigation.js